import { Notification } from "../entities/notification";
import NotificationRepository from "../usecases/ports/notificationRepository";
import { 
  Timestamp,
  db,
  auth,
  collection,
  collectionGroup,
  addDoc,
  where,
  orderBy,
  startAfter,
  limit,
  query,
  getDocs,
  updateDoc,
  doc,
} from './../../firebase';

export default class NotificationFirebaseImpl implements NotificationRepository {
  addNotification = async (notification: Notification): Promise<any> => {
    try {
      const timestamp = Timestamp.now();
      const notificationRef = collection(db, "notification");
      const notificationData = {
        ...notification,
        read: false,
        createdAt: timestamp,
        updatedAt: timestamp,
      };
      await addDoc(notificationRef, notificationData);
    } catch (error) {
      throw error;
    }
  };

  fetchNotifications = async (
    whereQuery?: [
      string,
      "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
      string | number | boolean | null | Date | Array<any>
    ][],
    startAfterQuery?: any,
    limitQuery?: number
  ): Promise<{
    data?: Notification[];
    lastElement?: unknown;
    firstElement?: unknown;
  }> => {
    try {
      const notificationRef = collectionGroup(db, "notification");
      const queryConstraints: any[] = [orderBy("createdAt", "desc")];
      const transformData: any[] = [];

      if (whereQuery && whereQuery.length > 0) {
        whereQuery.forEach((element) => {
          queryConstraints.push(where(element[0], element[1], element[2]));
        });
      };

      if (startAfterQuery) {
        queryConstraints.push(startAfter(startAfterQuery));
      }

      if (limitQuery) {
        queryConstraints.push(limit(limitQuery));
      }

      const q = query(
        notificationRef,
        ...queryConstraints,
      );

      const notifDocData = await getDocs(q);

      notifDocData.forEach(data => {
        const _data = data.data();
        transformData.push({
          id: data.id,
          ..._data,
          docData: data,
        });
      });

      return {
        data: transformData,
        lastElement: notifDocData?.docs[notifDocData?.docs.length - 1],
        firstElement: notifDocData?.docs[0],
      };

    } catch (error) {
      throw error
    }
  };

  updateNotification = async (id: string, data: Partial<Notification>): Promise<void> => {
    try {
      const notifRef = doc(db, "notification", id);
      await updateDoc(notifRef, data);
    } catch (error) {
      throw error;
    }
  }

  fetchNotificationsCount = async (
    isAdmin?: boolean,
    whereQuery?: [
      string,
      "<" | "<=" | "==" | ">=" | ">" | "!=" | "in",
      string | number | boolean | null | Date | Array<any>
    ][],
    startAfterQuery?: unknown,
    limitQuery?: number
  ): Promise<any> => {
    try {
      const queryConstraints: any[] = [orderBy('user.id'), orderBy("createdAt", "asc")];
      const notificationRef = collection(db, 'notification');

      if (whereQuery && whereQuery.length > 0) {
        whereQuery.forEach((element) => {
          queryConstraints.push(where(element[0], element[1], element[2]));
        });
      };

      if (limitQuery) {
        queryConstraints.push(limit(limitQuery));
      }

      if (startAfterQuery) {
        queryConstraints.push(startAfter(startAfterQuery));
      }

      const q = query(
        notificationRef,
        ...queryConstraints,
      );
      const notifDocData = await getDocs(q);

      const _data : any[] = notifDocData.docs.filter(data => {
        const user = auth.currentUser;
        const notification = data.data();
        const isInterviewer = !!notification?.interviewers?.find((i: any) => i.name === user?.displayName);

        if ((notification.type === 'commented' && !notification.description.includes(user?.displayName) && isAdmin) ||
            (notification.type === 'schedule' && notification?.interviewers?.length && !isInterviewer && isAdmin)) {
              return false;
          }
          
          return true;
      });

      return _data.length;
    } catch (error) { 
      throw error
    }
  };
}